import React from 'react';
import styles from './styles.scss';

function NotFound () {
  return (
    <div>
      <div className="main-body">
        <div className="container-fluid main-container not-found">
          <div className="col-md-10 col-md-offset-1 col-sm-12 text-center">
            <div className={styles.notFound}>
              <div className={`h1 ${styles.fourOhFour}`}>404</div>
              <div className="h1">NOT FOUND</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/NotFound/index.js